import React from "react";
import { withFormsy } from "formsy-react";
import { FormGroup, FormFeedback, Label } from "reactstrap";
import Select from "react-select";

export class MySelectComponent extends React.Component {
  state = {
    selectedOption: null
  };

  changeValue = selectedOption => {
    this.setState({ selectedOption });
    this.props.setValue(selectedOption);
  };

  render() {
    const errorMessage = this.props.getErrorMessage();
    const {
      options,
      validating,
      valueKey,
      labelKey,
      disabled,
      showRequired,
      onChange,
      showError,
      name,
      getValue,
      title,
      isPristine,
      isRequired,
      hasValue,
      isClearable
    } = this.props;
    const { selectedOption } = this.state;
    const hasError = !isPristine() && (showError() || !hasValue());
    return (
      <FormGroup>
        <Label className={isRequired() && "required"} htmlFor={name}>
          {title}
        </Label>
        <Select
          value={getValue() || selectedOption}
          className={hasError ? "is-invalid" : ""}
          options={options}
          isDisabled={validating ? true : false || disabled}
          name={name}
          isClearable={isClearable}
          onChange={onChange || this.changeValue}
          getOptionLabel={option => option[labelKey]}
          getOptionValue={option => option[valueKey]}
        />
        {hasError ? <FormFeedback>{errorMessage}</FormFeedback> : ""}
        {showRequired() ? <FormFeedback>Required</FormFeedback> : ""}
      </FormGroup>
    );
  }
}

const FormSelect = withFormsy(MySelectComponent);

export { FormSelect as MySelect };
